<template>
  <Navbar />
  <Header :title="en?'NCCU Overview':title" v-if="data.length != 0" :sticky="sticky">
      <h2>{{ en?'Information':'資料說明'}}</h2>
      <!-- <font-awesome-icon :icon="['fas', 'earth-americas']" />  
      <template v-if="!en">
        <span  class="intro-lan-focus">中 </span> | <span class="intro-lan" @click="changeLan">English</span>
      </template>
      <template v-else>
        <span class="intro-lan" @click="changeLan">中 </span> | <span class="intro-lan-focus">English</span>
      </template> -->

      <ul>
          <li>{{ en?'Data Year:':'資料範圍：' }}  
              <select class="select" v-model="selectYear" @change="changeYear(selectYear)">
                  <template v-for="(year, index) in yearArr" :key="index">
                      <option :value="year">{{ en? year+1911:year }} </option>
                  </template>
              </select> 
              {{ en?'':'學年度' }}</li>
          <li v-if="!en">畢業流向資料：{{ data.section_four_chart.dataInfo }}</li>
          <li v-else>Alumni Career Development:  {{ data.section_four_chart.dataInfoEn }}</li>
          <li v-if="!en">研究所包含碩士、博士及在職專班</li>
          <li v-if="!en">資料來源：本校註冊組、大專校院校務資訊公開平臺</li>
      </ul>
      <p v-if="!en" class="intro-note">本網頁不支援Internet Explore瀏覽器，為提供最佳的網路體驗，建議使用Chrome, Firefox等瀏覽器</p>
      <p v-else class="intro-note">This website is not supported by Internet Explorer. For better experience, we suggest using Chrome, Firefox or other browsers to browse.</p>
  </Header>

  <Header :title="title" v-else>
    <Loader />
  </Header>

  <Totop />

  <div class="section-tab" :class="{'sticky-tab-pt': sticky}">
    <ul v-if="!en">
        <li id="toStudent" class="student"><a href="#section_1">學生</a></li>
        <li id="toTeacher" class="teacher"><a href="#section_6">教師</a></li>
        <li v-if="selectYear <= lastestYear" id="toResearch" class="research"><a href="#section_9">研究</a></li>
        <li id="toOther" class="other"><a href="#section_10">校務</a></li>
    </ul>

    <ul v-else>
        <li id="toStudent" class="student"><a href="#section_1">STUDENT</a></li>
        <li id="toTeacher" class="teacher"><a href="#section_6">TEACHER</a></li>
        <li id="toResearch" class="research"><a href="#section_9">RESEARCH</a></li>
        <li id="toOther" class="other"><a href="#section_10">OTHER</a></li>
    </ul>
  </div>

  
  <OverviewComp v-if="data.length != 0" :data="data" :datayear="yearArr[0]" :lastestyear="lastestYear" :en="en"/>
  <section class="section-container" v-else>
    <Loader />
  </section>


  <Footer />
</template>

<script>
import Navbar from "@/components/Navbar.vue";
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import OverviewComp from "@/components/OverviewComp.vue";
import Loader from "@/components/Loader.vue";
import Totop from "@/components/Totop.vue";

gsap.registerPlugin(ScrollTrigger);

export default {
  name: "App",
  components: { Navbar, Header, Footer, OverviewComp, Loader, Totop },
  data() {
    return {
      title: "歷年政大概覽",
      data: [],
      sticky: false,
      selectYear: "",
      yearArr:[],
      lastestYear: "",
      en: false
    };
  },

  methods: {
    changeYear: function(selectYear) {
        fetch("data/data_"+selectYear+".json")
            .then((respond) => respond.json())
            .then((data) => {
              debugger;
              this.data = data;

            })
            .catch((err) => console.log(err.message));   
    },

    handleScroll: function(){
      let bannerImg = document.querySelector('.banner img');
      let bannerImgHeight;
      if(bannerImg) bannerImgHeight = bannerImg.offsetHeight;
  
      if (window.pageYOffset > bannerImgHeight) this.sticky = true;
      else this.sticky = false;
      
    },

    changeLan: function(){ {
      this.en = !this.en;
    }
  },
    
  },

  mounted() {
    fetch("../data/data_years.json", {cache: "reload"})
      .then((respond) => respond.json())
      .then((data) => {
          this.selectYear = data.thisYear;
          this.yearArr = data.yearArr;
          this.lastestYear = data.completedata;

          const dataUrl = "../data/data_"+this.selectYear+".json"
          fetch(dataUrl)
            .then((respond) => respond.json())
            .then((data) => {
              setTimeout(() => {
                this.data = data;
              }, 300);
            })
            .catch((err) => console.log(err.message));
      })
    .catch((err) => console.log(err.message));
    
    window.addEventListener('scroll', this.handleScroll)
  },
};
</script>

<style src="@/assets/css/overviewHeader.css" scoped></style>

<style scoped>
  .sticky-tab-pt {
    padding-top: 140px;
  }

  .sticky ul li {
    display: inline-block;
    margin: 12px;
  }

  .sticky p {
    display: none;
  }
</style>

